import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  // cceUrl = 'http://opsdev.kshema.co/cceops';

  cceUrl = 'https://uat02.kshema.co/cce-ops';

  // cceUrl = 'http://ops.omdc.co.in/cceops';

  // cceUrl = 'http://localhost:8080'

  AuthToken: any;
  resData: any;

  constructor(private http: HttpClient, private storage: Storage) {}

  async SetAuthorization() {
    this.storage.create();
    await this.storage.get('AuthToken').then((AuthToken) => {
      this.AuthToken = AuthToken;
    });
  }

  getToken(childid: any, sourceid: any) {
    const data = { childid: childid, sourceid: sourceid };
    let headers = new HttpHeaders({
      Authorization: 'Basic ' + btoa('cceandroid' + ':' + 'i luv Kshema'),
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Methods': 'POST',
      // 'Access-Control-Allow-Origin':' *',
      // 'Access-Control-Request-Headers': 'Authorization',
      // 'Access-Control-Allow-Headers':'Authorization',
    });
    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/REST/authentication', JSON.stringify(data), {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
            this.resData = res;
            this.AuthToken = this.resData[0]?.token;
            // this.api.AuthToken=this.AuthToken;

            this.storage.set('AuthToken', this.AuthToken);
            this.SetAuthorization();
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async rbackLogin(username, password) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl +
            '/cceUserRegistrationController/userCheck?username=' +
            username +
            '&password=' +
            password,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async userlogin(username, password) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    // const formData = {
    //   'username' : username,
    //   'password' : password
    // }

    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      // Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/REST/login', formData, { headers: headers })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async cceExcelImport(formData) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/cce/excelImportNew', formData, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  // cceDataUpload(data){
  //   return new Promise((resolve, reject) => {
  //     this.http.post(this.cceUrl + '/cce/cceDataUpload/hp/up', data).subscribe(
  //       (res:any) => {
  //         resolve(res)
  //       },(err) => {
  //         reject(err)
  //       }
  //     )
  //   })
  // }

  async cceUserExcelImport(formData, params) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/cceUsers/excelImportNew', formData, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  // cceUserDataUpload(data){
  //   return new Promise((resolve, reject) => {
  //     this.http.post(this.cceUrl + '/cceUsers/cceUsersUpload/hp/up', data).subscribe(
  //       (res:any) => {
  //         resolve(res)
  //       },(err) => {
  //         reject(err)
  //       }
  //     )
  //   })
  // }

  async getCcUsersData(requestBody) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }

    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/cceUsers/getcceusersdata', requestBody, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getCcExperimentData(requestBody) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .post(
          this.cceUrl + '/dashboardController/getcceExperimentData',
          requestBody,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  async manualExperimentDownload(formData) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl +
            '/experiments-download?season=' +
            formData.season +
            '&year=' +
            formData.year +
            '&state=' +
            formData.state +
            '&fromDate=' +
            formData.fromDate +
            '&toDate=' +
            formData?.toDate,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async cceExperimentDownload(data) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl + '/dashboardController/download-excel', {
          headers: headers,
          params: data,
        }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getcceimage(cceid) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }

    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      // this.http.get(this.cceUrl + '/cce/cceData/cceImages/' + 'CCE1694680359252' + "/images", {headers : headers}).subscribe(
      // this.http.get('https://uat01.kshema.co/cce/cce/cceData/cceImages/CCE1695641028705' + "/images", {headers : headers}).subscribe(
      this.http
        .get(this.cceUrl + '/cce/cceData/cceImages/' + cceid + '/images', {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getcceVideos(cceid, filename) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }

    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl +
            '/cce/cceData/cceVideos/' +
            cceid +
            '/' +
            cceid +
            '_' +
            filename,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getccefarmerdetails(cceid) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/REST/getfarmerdetails?cceid=' + cceid, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getccedetailsbycceid(cceid: any) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/REST/getccedetailsbycceid?cceId=' + cceid, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getccefarmdetails(cceid) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/REST/getfarmdetails?cceid=' + cceid, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getccedetails(cceid) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/REST/getccedata?cceid=' + cceid, {
          headers: headers,
        })
        .subscribe(
          // this.http.get(this.cceUrl + "/getccedata?cceid=" + cceid, {headers : headers}).subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getpickingdetails(cceid) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl + '/dashboardController/getPicking/{pickingId}' + cceid,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getDashboard(data) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      // this.http.post(this.cceUrl + '/getCceDashboardData', data, {headers : headers}).subscribe(
      // http://opsdev.kshema.co/cceops/dashboardController/get-dash-board/?state=Haryana&district=Yamunanagar&offset=0&limit=25
      this.http
        .get(this.cceUrl + '/dashboardController/get-dash-board/', {
          headers: headers,
          params: data,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getCCEExperimentData(data) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      // this.http.post(this.cceUrl + '/getCceDashboardData', data, {headers : headers}).subscribe(
      this.http
        .post(
          this.cceUrl + '/dashboardController/getAllCCEExperimentData',
          data,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getAllStates() {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/cceUserRegistrationController/getStateMaster', {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getDistrict(state) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/REST/getdistrictsdetails?state=' + state, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getBlock(stateId, state, districtId, district) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl +
            '/REST/getBlockDetails?stateId=' +
            stateId +
            '&state=' +
            state +
            '&districtId=' +
            districtId +
            '&district=' +
            district,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async userUpadte(data) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/cceUsers/updateCCEUser', data, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async experimentUpdate(data) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/cce/updateCCE', data, { headers: headers })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }
  async updatefarmdetails(requestBody) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.cceUrl + '/dashboardController/updateFarmDetails',
          requestBody,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }
  async updateccedetails(requestBody) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.cceUrl + '/dashboardController/updateCceDetails',
          requestBody,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }
  async getStateMaster() {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/cceUserRegistrationController/getStateMaster', {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getAllDistrictsByState(state: string) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl +
            '/cceUserRegistrationController/getAllDistrictsByState?state=' +
            state,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async registerUser(data) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .post(
          this.cceUrl + '/cceUserRegistrationController/registerUser',
          data,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async deactivateUser(data) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .post(
          this.cceUrl + '/cceUserRegistrationController/deactivateUser',
          data,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getUserDetails() {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/userMasterController/getUserDetails', {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async saveMappedModule(data) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .post(
          this.cceUrl + '/userModuleMapController/saveMappedModules',
          data,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getRoles() {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }

    let accessModulesList = await JSON.parse(
      sessionStorage.getItem('accessModules')
    );

    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    // const formData = new FormData()
    // formData.append("userName","lak")
    // formData.append('headers', headers)

    const body = {
      userName: accessModulesList.userName,
    };

    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/cceUsers/getCCEUserRoles', body, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async createCceUser(addUser) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/cceUsers/createCCEUser', addUser, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async updateCceUser(updateUser) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/cceUsers/updateCCEUser', updateUser, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getStates() {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/REST/getstatesdetails', { headers: headers })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async addreason(requestBody) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }

    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .put(this.cceUrl + '/dashboardController/addReason', requestBody, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  async updateReason(requestBody) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }

    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    return new Promise((resolve, reject) => {
      this.http
        .put(this.cceUrl + '/dashboardController/updateReason', requestBody, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getMandals(state: any, district: any) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl +
            '/dashboardController/get-mandals?state=' +
            encodeURI(state) +
            '&district=' +
            encodeURI(district),
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getVillages(state: any, district: any, mandal: any) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl +
            '/dashboardController/get-villages?state=' +
            encodeURI(state) +
            '&district=' +
            encodeURI(district) +
            '&mandal=' +
            encodeURI(mandal),
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getGramPanchayats(
    state: any,
    district: any,
    mandal: any,
    village: any
  ) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.cceUrl +
            '/dashboardController/get-gram-panchayat?state=' +
            encodeURI(state) +
            '&district=' +
            encodeURI(district) +
            '&mandal=' +
            encodeURI(mandal) +
            '&village=' +
            encodeURI(village),
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getCrops(crop) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/dashboardController/get-crops?crop=' + crop, {
          headers: headers,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async getFilteredUserData(filters) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });

    const newfilters = {};

    for (const filter in filters) {
      if (filters[filter]) {
        newfilters[filter] = encodeURI(
          filters[filter].split('-')[1]
            ? filters[filter].split('-')[1]
            : filters[filter]
        );
      }
    }

    console.log(newfilters);
    return new Promise((resolve, reject) => {
      // this.http.post(this.cceUrl + '/getCceDashboardData', data, {headers : headers}).subscribe(
      this.http
        .get(
          this.cceUrl +
            '//ccescheduling?offset=0&limit=24&state=Himachal%20Pradesh&district=Una&startDate=2024-07-27&endDate=2024-07-27',
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  async getScheduleData(data) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/ccescheduling?', {
          headers: headers,
          params: data,
        })
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  async updatecceactivitydetails(requestBody) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }
    var headers = new HttpHeaders({
      // 'Access-Control-Allow-Origin': '*',
      // 'Content-Type' : 'multipart/form-data',
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.cceUrl + '/dashboardController/update-cce-details',
          requestBody,
          { headers: headers }
        )
        .subscribe(
          (res: any) => {
            resolve(res);
          },
          (err: any) => {
            reject(err);
          }
        );
    });
  }

  async postBulkUpload(file: File) {
    let accessModulesList = await JSON.parse(
      sessionStorage.getItem('accessModules')
    );
    var headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.AuthToken,
    });
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('userName', accessModulesList.userName);
    return new Promise((resolve, reject) => {
      this.http
        .post(this.cceUrl + '/experiments-upload', formData, {
          headers: headers,
          responseType: 'text',
        })
        .subscribe({
          next: (res: any) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }

  async downloadErrorLogs(fileId: string, fileName: string) {
    if (!this.AuthToken) {
      await this.getToken(999, 999);
    }

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.AuthToken,
    });

    const accessModulesList = JSON.parse(
      sessionStorage.getItem('accessModules') || '{}'
    );
    const uploadedBy = accessModulesList.userName;

    const params = new HttpParams()
      .set('fileId', fileId)
      .set('fileName', fileName)
      .set('uploadedBy', uploadedBy);

    return new Promise((resolve, reject) => {
      this.http
        .get(this.cceUrl + '/experiments-upload/error-logs', {
          headers: headers,
          params: params,
        })
        .subscribe({
          next: (res: any) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }
}
